import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const Callback = () => {
  const navigate = useNavigate();
  // const { fetchUser } = useAuth();

  const handleLogin = () => {
    localStorage.removeItem("access_token");
    navigate("/login", { replace: true });
  };
  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const ssoToken = urlParams.get("sso_token");

      if (ssoToken) {
        localStorage.setItem("access_token", ssoToken);
         navigate("/");
      } else {
        handleLogin();
      }
    };

    handleCallback();
  }, [navigate]);

  return null;
};

export default Callback;



// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const Callback = ({setFirst}) => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchToken = async () => {
//       const urlParams = new URLSearchParams(window.location.search);
//       const authCode = urlParams.get("code");
      
//       if (!authCode) {
//         console.error("Authorization code is missing.");
//         return;
//       }

//       try {
//         const response = await fetch(process.env.REACT_APP_TOKEN_ENDPOINT, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded",
//           },
//           body: new URLSearchParams({
//             grant_type: "authorization_code",
//             client_id: process.env.REACT_APP_CLIENT_ID,
//             client_secret: process.env.REACT_APP_CLIENT_SECRET,
//             redirect_uri: process.env.REACT_APP_REDIRECT_URI,
//             code: authCode,
//           }),
//         });

//         const data = await response.json();
        
//         if (data.access_token) {
//           localStorage.setItem("access_token", data.access_token);
//           setFirst(true);
//           navigate("/");
//         } else {
//           console.error("Failed to get access token", data);
//         }
//       } catch (error) {
//         console.error("Error fetching access token:", error);
//       }
//     };

//     fetchToken();
//   }, [navigate]);

//   return null;
// };

// export default Callback;